import * as Icons from 'react-pay-icons';
import { Box, Typography } from '@mui/material';
import { ElementType } from 'react';

type CardBrandIconProps = {
  cardType: string;
  width?: number;
  height?: number;
};

const CARD_ICONS: Record<string, ElementType> = {
  visa: Icons.Visa,
  mastercard: Icons.Mastercard,
  'master card': Icons.Mastercard,
  amex: Icons.Amex,
  'american express': Icons.Amex,
  discover: Icons.Discover,
  diners: Icons.Diners,
  'diners club': Icons.DinersClub,
  jcb: Icons.Jcb,
  unionpay: Icons.UnionPay,
  maestro: Icons.Maestro,
};

const normalizeCardType = (cardType: string) => cardType.trim().toLowerCase();

const CardBrandIcon = ({
  cardType,
  width = 40,
  height = 28,
}: CardBrandIconProps) => {
  const key = normalizeCardType(cardType);
  const Icon = key ? CARD_ICONS[key] : null;

  if (Icon) {
    return <Icon style={{ width, height, display: 'block' }} />;
  }

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: 1,
        bgcolor: 'grey.200',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: 10 }}>
        {cardType || 'CARD'}
      </Typography>
    </Box>
  );
};

export default CardBrandIcon;
